<template lang="pug">
  modal(:title='$t("folders.deleteModal.title")' @closeModal='hideElement({ element: "folderDeleteModal" })' :errorTitle='errorTitle')
    .row.middle.message
      simple-svg.icon.red-icon(:filepath='stopIcon' width='36px' height='36px')
      span.text-normal.description.width-100
        | {{ modalDescription }}
    .row.end
      button.primary-button(:class='{ "m-right-2": !error }' type='button' @click='handleCancel()')
        | {{ buttonText }}
      button.secondary-button(v-if='!error' type='button' @click='handleDelete()')
        | {{ $t('folders.deleteModal.delete') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { myFoldersTab } from '@/constants/folders'

import { deleteFolder } from '@/services/FolderService'
import { routes } from '@/router'

import Modal from '@/components/Modal'
import stopIcon from '@/assets/ic_stop.svg'

export default {
  data() {
    return {
      stopIcon,
      error: false
    }
  },
  methods: {
    ...mapActions(['hideElement', 'hydrateFolders']),
    handleDelete() {
      deleteFolder(this.folderId).then(response => {
        this.hideElement({ element: 'folderDeleteModal' })
        if (this.$route.name === routes.folderContent) {
          this.$router.push({
            name: routes.folderList,
            params: { rootTab: myFoldersTab }
          })
        }
        this.hydrateFolders()
      }).catch(() => {
        this.setErrorState()
        this.hydrateFolders()
      })
    },
    handleCancel() {
      this.hideElement({ element: 'folderDeleteModal' })
      this.$emit('cancel')
    },
    setErrorState() {
      this.error = true
    }
  },
  computed: {
    ...mapState({
      folderId: state => state.behavior.folderDeleteModal.props.folderId
    }),
    modalDescription() {
      return this.error ? this.$t('folders.deleteModal.errorDescription') : this.$t('folders.deleteModal.description')
    },
    buttonText() {
      return this.error ? this.$t('folders.deleteModal.ok') : this.$t('folders.deleteModal.cancel')
    },
    errorTitle() {
      return this.error ? this.$t('folders.deleteModal.errorTitle') : undefined
    }
  },
  components: { Modal }
}
</script>

<style lang="scss" scoped>
.message {
  margin: 50px 0;

  .icon {
    margin-right: 16px;
    height: 36px;
  }

  .description {
    max-width: 340px;
  }
}
</style>
